module.exports = __webpack_public_path__ + "720a74bd2bba077f0524e01ea9ece20a.webp";